import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
  TextField,
} from '@mui/material';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import dayjs from 'dayjs';

export function FieldDateTime({
  field, onChange, indexField, indexGroup, indexFormulario, customize, sx
}) {

  const [dateShow, setDateShow] = useState('')
  const [invalidFormat, setInvalidFormat] = useState(false)
 
  useEffect(()=>{
    field.value && setDateShow(field.value)
  },[])

  const changeDataShow=(e)=>{
      setInvalidFormat(false)
      console.log(e)
      setDateShow(e)
   // }
  }

  useEffect(() => {
    console.log('es',dateShow)
     onChange(indexField, dateShow!=="" && dateShow!==null ? dayjs(dateShow).format('YYYY-MM-DD'):"" , indexGroup, indexFormulario)
  }, [dateShow])

  useEffect(()=>{
    field.value && changeDataShow(field.value)
  },[field])

  
  

  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={field.label}
        inputFormat="DD/MM/YYYY"
        value={dateShow === '' ? null:dateShow }
        onChange={(e) => changeDataShow(e)}
        //onChange={(e) => changeDataShow(e)}
        defaultValue={false}
        renderInput={(params) => (
          <Box sx={{display:'flex', flexDirection:'row-reverse'}}>
            <TextField
              {...params}
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={sx ? sx : { mt: 2 }}
              size="small"
              value={dateShow}
              inputProps={{ ...params.inputProps, readOnly: true  }}
              FormHelperTextProps={{
                sx: {
                  color: customize.HelperText.color,
                  fontSize: customize.HelperText.size,
                },
              }}

              error={invalidFormat && dateShow===''}
              helperText={field.required && (invalidFormat|| dateShow==='') ? '* Campo Obligatorio' : ''}
            />
           { dateShow && <IconButton sx={{ display: 'inline-flex', position:'absolute', right:45 }} onClick={() => changeDataShow(null)}>
              <ClearIcon />
            </IconButton>}

          </Box>

        )}
        orientation="portrait"
      />
    </LocalizationProvider>
    </>
  );
}

FieldDateTime.propTypes = {
  field: PropTypes.objectOf.isRequired,
  onChange: PropTypes.func.isRequired,
  indexField: PropTypes.number.isRequired,
  indexGroup: PropTypes.number.isRequired,
  customize: PropTypes.objectOf.isRequired,
};

export default FieldDateTime;



